export const PeriodTypeList = [
  { name: '전체 기간', value: '1' },
  { name: '일주일', value: '2' },
  { name: '1개월', value: '3' },
];

export const ExcludeStatusType01 = [
  { name: '전체', value: 0 },
  { name: '작성중', value: 1 },
  { name: '예약 완료', value: 2 },
  { name: '등록 완료', value: 3 },
];

export const ProgramBoardStatusList = [
  { name: '전체', value: 0 },
  { name: '비공개', value: 1 },
  { name: '인증 취소', value: 2 },
];

export const ExcludeStatusType02 = [
  { name: '전체', value: 1 },
  { name: '활성', value: 2 },
  { name: '비활성', value: 3 },
];

export const AttendFilterType = [
  { name: '전체', value: 0 },
  { name: '커뮤니티', value: 1 },
  { name: '챌린지', value: 2 },
];

export const challengeStatusType = [
  { name: '전체', value: 0 },
  { name: '작성중', value: 1 },
  { name: '접수 요청', value: 2 },
  { name: '수정 요청', value: 3 },
  { name: '테스트 생성', value: 4 },
  { name: '접수 완료', value: 5 },
  { name: '사용 불가', value: 6 },
];

export const courseStatusType = [
  { name: '전체', value: 0 },
  { name: '작성중', value: 1 },
  { name: '접수 요청', value: 2 },
  { name: '수정 요청', value: 3 },
  { name: '접수 완료', value: 4 },
  { name: '사용 불가', value: 5 },
];

export const SortWayType01 = [
  { name: '최신순', value: 1 },
  { name: '오래된 순', value: 2 },
  { name: '조회순', value: 3 },
];

export const SortWayType02 = [
  { name: '최신순', value: 1 },
  { name: '오래된 순', value: 2 },
];

export const SortWayType03 = [
  { name: '최신순', value: 1 },
  { name: '참여자 많은 순', value: 2 },
];

export const SortWayType04 = [
  { name: '최신순', value: 0 },
  { name: '오래된순', value: 1 },
  { name: '댓글순', value: 2 },
  { name: '좋아요순', value: 3 },
];

export const QnATypeOption: { name: string; value: 0 | 1 | 2 }[] = [
  { name: '전체', value: 0 },
  { name: '설문조사', value: 1 },
  { name: '퀴즈', value: 2 },
];

export const QnARewardOption: { name: string; value: 0 | 1 | 2 }[] = [
  { name: '전체', value: 0 },
  { name: '지급', value: 1 },
  { name: '미지급', value: 2 },
];

export const QnAStatusOption: {
  name: string;
  value: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}[] = [
  { name: '전체', value: 0 },
  { name: '작성중', value: 1 },
  { name: '접수 요청', value: 2 },
  { name: '수정 요청', value: 3 },
  { name: '진행 대기', value: 4 },
  { name: '진행 중', value: 5 },
  { name: '종료', value: 6 },
];
export interface AmdCode {
  amdCode: number;
  regionName: string;
}

export const AMD_CODE_LIST: AmdCode[] = [
  { amdCode: 11, regionName: '서울' },
  { amdCode: 26, regionName: '부산' },
  { amdCode: 27, regionName: '대구' },
  { amdCode: 28, regionName: '인천' },
  { amdCode: 29, regionName: '광주' },
  { amdCode: 30, regionName: '대전' },
  { amdCode: 31, regionName: '울산' },
  { amdCode: 36, regionName: '세종' },
  { amdCode: 41, regionName: '경기도' },
  // { amdCode: 42, regionName: '강원도' },
  { amdCode: 51, regionName: '강원특별자치도' },
  { amdCode: 43, regionName: '충청북도' },
  { amdCode: 44, regionName: '충청남도' },
  // { amdCode: 45, regionName: '전라북도' },
  { amdCode: 52, regionName: '전북특별자치도' },
  { amdCode: 46, regionName: '전라남도' },
  { amdCode: 47, regionName: '경상북도' },
  { amdCode: 48, regionName: '경상남도' },
  { amdCode: 50, regionName: '제주특별자치도' },
];

export interface IRewardReceiveType {
  name: string;
  value: number;
  condition?: (isShow: boolean) => boolean;
}

export const RewardFormType = [
  { name: '배송지 신청 양식', value: 0 },
  { name: '지역 화폐 신청 양식', value: 1 },
];

export enum registerStatus {
  '전체' = 0,
  '작성중',
  '접수 요청',
  '수정 요청',
  '테스트 생성',
  '접수 완료',
  '사용 불가',
}

export const MedalType = [
  { value: 'gold', name: '금' },
  { value: 'silver', name: '은' },
  { value: 'bronze', name: '동' },
  { value: 'empty', name: '메달없음' },
];

export const GenderType = [
  { value: 'male', name: '남성' },
  { value: 'female', name: '여성' },
  { value: 'unknown', name: '미상' },
];

export const GenderType02 = [
  { value: 0, name: '미상' },
  { value: 1, name: '남성' },
  { value: 2, name: '여성' },
];

export interface GraphDataValueType {
  type: number;
  name: string;
  colorIndex: number;
}

export const ProgramGenderType: GraphDataValueType[] = [
  { type: 1, name: '남성', colorIndex: 1 },
  { type: 0, name: '여성', colorIndex: 2 },
  { type: -1, name: '미상', colorIndex: 8 },
];

// 0-10대미만 1-10대 ... 7-70대이상 (-1:미상)

export const ProgramAgeType: GraphDataValueType[] = [
  { type: 7, name: '70대 이상', colorIndex: 0 },
  { type: 6, name: '60대', colorIndex: 1 },
  { type: 5, name: '50대', colorIndex: 2 },
  { type: 4, name: '40대', colorIndex: 3 },
  { type: 3, name: '30대', colorIndex: 4 },
  { type: 2, name: '20대', colorIndex: 5 },
  { type: 1, name: '10대', colorIndex: 6 },
  { type: 0, name: '10대 미만', colorIndex: 7 },
  { type: -1, name: '미상', colorIndex: 8 },
];

export const ProgramGraphAgeType = [
  { value: 0, name: '10대 미만' },
  { value: 1, name: '10대' },
  { value: 2, name: '20대' },
  { value: 3, name: '30대' },
  { value: 4, name: '40대' },
  { value: 5, name: '50대' },
  { value: 6, name: '60대' },
  { value: 7, name: '70대 이상' },
  { value: -1, name: '미상' },
];

export const ProgramBMIType: GraphDataValueType[] = [
  { type: 1, name: '저체중', colorIndex: 0 },
  { type: 2, name: '정상', colorIndex: 1 },
  { type: 3, name: '과체중', colorIndex: 2 },
  { type: 4, name: '비만', colorIndex: 3 },
  { type: 5, name: '고도비만', colorIndex: 4 },
  { type: -1, name: '미상', colorIndex: 8 },
];

export const ProgramBloodPressureType: GraphDataValueType[] = [
  { type: 1, name: '정상 혈압', colorIndex: 0 },
  { type: 2, name: '주의 혈압', colorIndex: 1 },
  { type: 3, name: '고혈압 전단계', colorIndex: 2 },
  { type: 4, name: '고혈압 1기', colorIndex: 3 },
  { type: 5, name: '고혈압 2기', colorIndex: 4 },
  { type: -1, name: '미상', colorIndex: 8 },
];

export const ProgramBloodSugarType: GraphDataValueType[] = [
  { type: 1, name: '정상', colorIndex: 0 },
  { type: 2, name: '전당뇨', colorIndex: 2 },
  { type: 3, name: '당뇨', colorIndex: 4 },
  { type: -1, name: '미상', colorIndex: 8 },
];

export const ProgramSmokingType: GraphDataValueType[] = [
  { type: 1, name: '주 1일', colorIndex: 0 },
  { type: 2, name: '주 2일', colorIndex: 1 },
  { type: 3, name: '주 3일', colorIndex: 2 },
  { type: 4, name: '주 4일', colorIndex: 3 },
  { type: 5, name: '주 5일', colorIndex: 4 },
  { type: 6, name: '주 6일', colorIndex: 5 },
  { type: 7, name: '주 7일', colorIndex: 6 },
];

export const ProgramStressType: GraphDataValueType[] = [
  { type: 1, name: '최고', colorIndex: 0 },
  { type: 2, name: '좋음', colorIndex: 1 },
  { type: 3, name: '보통', colorIndex: 2 },
  { type: 4, name: '나쁨', colorIndex: 3 },
  { type: 5, name: '최악', colorIndex: 4 },
  { type: -1, name: '미상', colorIndex: 8 },
];

export const ProgramWalkTimeGroup: GraphDataValueType[] = [
  { type: 1, name: '오전', colorIndex: 0 },
  { type: 2, name: '점심', colorIndex: 1 },
  { type: 3, name: '오후', colorIndex: 2 },
  { type: 4, name: '저녁', colorIndex: 3 },
  { type: 0, name: '새벽', colorIndex: 4 },
];

export const AgeType = [
  { value: '0', name: '10대 미만' },
  { value: '10', name: '10대' },
  { value: '20', name: '20대' },
  { value: '30', name: '30대' },
  { value: '40', name: '40대' },
  { value: '50', name: '50대' },
  { value: '60', name: '60대' },
  { value: '70', name: '70대 이상' },
  { value: '-1', name: '미상' },
];

export const BMIType = [
  { value: 1, name: '저체중' },
  { value: 2, name: '정상' },
  { value: 3, name: '과체중' },
  { value: 4, name: '비만' },
  { value: 5, name: '고도비만' },
  { value: 0, name: '미상' },
];

export const WalkPeriodType = [
  { value: '0', name: '새벽 00:00 ~ 06:00' },
  { value: '1', name: '아침 06:00 ~ 11:00' },
  { value: '2', name: '점심 11:00 ~ 14:00' },
  { value: '3', name: '오후 14:00 ~ 18:00' },
  { value: '4', name: '저녁 18:00 ~ 24:00' },
];

export const DayList = [
  { value: 1, name: '월요일' },
  { value: 2, name: '화요일' },
  { value: 3, name: '수요일' },
  { value: 4, name: '목요일' },
  { value: 5, name: '금요일' },
  { value: 6, name: '토요일' },
  { value: 0, name: '일요일' },
];

export const DayList02 = [
  { value: 1, name: '일요일' },
  { value: 2, name: '월요일' },
  { value: 3, name: '화요일' },
  { value: 4, name: '수요일' },
  { value: 5, name: '목요일' },
  { value: 6, name: '금요일' },
  { value: 7, name: '토요일' },
];

export const DayList03 = [
  { value: 0, name: '월요일' },
  { value: 1, name: '화요일' },
  { value: 2, name: '수요일' },
  { value: 3, name: '목요일' },
  { value: 4, name: '금요일' },
  { value: 5, name: '토요일' },
  { value: 6, name: '일요일' },
];
